import React, { useState, useEffect } from 'react';
import { Card, Descriptions, Tag, Image, Spin, message } from 'antd';
import { inspectionApi } from '../../services/api';

const PHOTO_TYPE_NAMES = {
  1: '原石照片', 2: '生产过程照片', 3: '成品照片', 4: '检测证书',
  5: '切料照片', 6: '规划照片', 7: '手修照片', 8: '抛光照片',
  9: '原石入库照片', 10: '切料标块照片', 11: '打柱照片', 12: '磨珠照片', 13: '穿珠子照片'
};

const BEAD_CATEGORIES = ['珠子', '手串', '项链'];

const ProductDetailModal = ({ productId, visible }) => {
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState(null);

  useEffect(() => {
    if (visible && productId) {
      fetchProduct();
    }
    if (!visible) {
      setProduct(null);
    }
  }, [visible, productId]);

  const fetchProduct = async () => {
    setLoading(true);
    try {
      const res = await inspectionApi.productDetail(productId);
      setProduct(res.data);
    } catch (err) {
      message.error('获取货品详情失败');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{ textAlign: 'center', padding: 60 }}><Spin size="large" /></div>;
  }

  if (!product) {
    return <div style={{ textAlign: 'center', padding: 60 }}><Spin size="large" /></div>;
  }

  const isBeadCategory = BEAD_CATEGORIES.includes(product.batch_category || product.category);
  const batchPhotoTypes = isBeadCategory
    ? [1, 9, 5, 10, 11, 12, 13]
    : [1, 9, 5, 10, 6, 7, 8];
  const productPhotoTypes = [3, 4];

  const renderPhotoSection = (photoType) => {
    const photos = product.photos?.[String(photoType)] || [];
    const name = PHOTO_TYPE_NAMES[photoType] || `类型${photoType}`;
    return (
      <Card title={name} key={photoType} style={{ marginBottom: 16 }} size="small">
        {photos.length > 0 ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
            {photos.map(photo => (
              <div key={photo.id} style={{ width: 160 }}>
                <Image
                  src={photo.url}
                  alt=""
                  width={160}
                  height={120}
                  style={{ objectFit: 'cover', borderRadius: 4 }}
                  loading="lazy"
                />
                {photo.description && (
                  <div style={{ fontSize: 12, color: '#666', marginTop: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {photo.description}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div style={{ textAlign: 'center', color: '#ccc', padding: 20 }}>暂无{name}</div>
        )}
      </Card>
    );
  };

  return (
    <div>
      <Card style={{ marginBottom: 16 }}>
        <Descriptions column={3} size="small">
          <Descriptions.Item label="货品编码"><code style={{ color: '#1890ff' }}>{product.product_code}</code></Descriptions.Item>
          <Descriptions.Item label="货品名称">{product.name}</Descriptions.Item>
          <Descriptions.Item label="品类">{(product.batch_category || product.category) ? <Tag color="#1890ff">{product.batch_category || product.category}</Tag> : '-'}</Descriptions.Item>
          <Descriptions.Item label="材质">{product.material || '-'}</Descriptions.Item>
          <Descriptions.Item label="重量">{product.weight ? `${product.weight}g` : '-'}</Descriptions.Item>
          <Descriptions.Item label="尺寸">{product.dimensions || '-'}</Descriptions.Item>
          <Descriptions.Item label="工艺师">{product.crafts_man || '-'}</Descriptions.Item>
          <Descriptions.Item label="完工日期">{product.finish_date ? product.finish_date.split('T')[0] : '-'}</Descriptions.Item>
          <Descriptions.Item label="所属公司"><Tag>{product.company_name || '-'}</Tag></Descriptions.Item>
          <Descriptions.Item label="原石产地">{product.raw_material_origin || '-'}</Descriptions.Item>
          <Descriptions.Item label="料种">{product.jade_type_name || '-'}</Descriptions.Item>
        </Descriptions>
        {product.description && (
          <div style={{ marginTop: 12, color: '#666' }}>{product.description}</div>
        )}
      </Card>

      {batchPhotoTypes.map(renderPhotoSection)}
      {productPhotoTypes.map(renderPhotoSection)}
    </div>
  );
};

export default ProductDetailModal;
